import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Obrigado from "@/pages/Obrigado";
import Triagem from "@/pages/Triagem";
import AdminLogin from "@/pages/AdminLogin";
import AuthCallback from "@/pages/AuthCallback";
import AdminTriagem from "@/pages/AdminTriagem";
import AdminLembrancas from "@/pages/AdminLembrancas";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/triagem" element={<Triagem />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/callback" element={<AuthCallback />} />
          <Route path="/admin/triagem" element={<AdminTriagem />} />
          <Route path="/admin/lembrancas" element={<AdminLembrancas />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
